function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "la-carretera",
  transform: "translate(0 -3.413)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_156",
  "data-name": "Grupo 156",
  transform: "translate(0 3.413)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_155",
  "data-name": "Grupo 155",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_228",
  "data-name": "Trazado 228",
  d: "M126.023,37.855l-5.912-13.089a2.012,2.012,0,0,0-1.868-.994H83.905L78.792,4.587a1.917,1.917,0,0,0-1.934-1.174H49.268a1.917,1.917,0,0,0-1.934,1.174L42.221,23.773H7.883a2.012,2.012,0,0,0-1.868.994L.1,37.855a1.146,1.146,0,0,0,.269,1.31,2.255,2.255,0,0,0,1.6.6H4.876c1.089,0,1.971-.651,1.971-1.454s-.882-1.454-1.971-1.454H4.7l4.6-10.18H43.841a1.919,1.919,0,0,0,1.935-1.174L50.889,6.321H75.237l5.114,19.186a1.917,1.917,0,0,0,1.934,1.174h34.538l4.6,10.18h-.668c-1.089,0-1.971.651-1.971,1.454s.882,1.454,1.971,1.454h3.4a2.256,2.256,0,0,0,1.6-.6A1.148,1.148,0,0,0,126.023,37.855Z",
  transform: "translate(0 -3.413)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_158",
  "data-name": "Grupo 158",
  transform: "translate(23.648 36.861)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_157",
  "data-name": "Grupo 157"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_229",
  "data-name": "Trazado 229",
  d: "M160.712,216.862l-14.27-53.528h8.372c1.089,0,1.971-.651,1.971-1.454s-.882-1.454-1.971-1.454H144.046a2.3,2.3,0,0,0-1.522.531,1.192,1.192,0,0,0-.412,1.2l14.271,53.528h-70.1l14.271-53.529a1.191,1.191,0,0,0-.412-1.2,2.307,2.307,0,0,0-1.522-.53H88.835c-1.089,0-1.971.651-1.971,1.454s.882,1.454,1.971,1.454h7.392L81.956,216.863a1.192,1.192,0,0,0,.412,1.2,2.307,2.307,0,0,0,1.522.53h74.887a2.305,2.305,0,0,0,1.522-.531A1.192,1.192,0,0,0,160.712,216.862Z",
  transform: "translate(-81.919 -160.426)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_160",
  "data-name": "Grupo 160",
  transform: "translate(106.419 60.13)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_159",
  "data-name": "Grupo 159"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_32",
  "data-name": "Rect\\xE1ngulo 32",
  width: 3.941,
  height: 18.906
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_162",
  "data-name": "Grupo 162",
  transform: "translate(27.59 29.59)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_161",
  "data-name": "Grupo 161"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_230",
  "data-name": "Trazado 230",
  d: "M105.427,126.293H97.544c-1.089,0-1.971.651-1.971,1.454s.882,1.454,1.971,1.454h7.883c1.089,0,1.971-.651,1.971-1.454S106.516,126.293,105.427,126.293Z",
  transform: "translate(-95.573 -126.293)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_164",
  "data-name": "Grupo 164",
  transform: "translate(86.689 29.59)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_163",
  "data-name": "Grupo 163"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_231",
  "data-name": "Trazado 231",
  d: "M310.149,126.293h-7.883c-1.089,0-1.971.651-1.971,1.454s.882,1.454,1.971,1.454h7.883c1.089,0,1.971-.651,1.971-1.454S311.237,126.293,310.149,126.293Z",
  transform: "translate(-300.295 -126.293)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_167",
  "data-name": "Grupo 167",
  transform: "translate(61.092 6.321)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_166",
  "data-name": "Grupo 166"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_165",
  "data-name": "Grupo 165"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_232",
  "data-name": "Trazado 232",
  d: "M213.6,215.04c-1.089,0-1.971.651-1.971,1.454v5.817c0,.8.882,1.454,1.971,1.454s1.971-.651,1.971-1.454v-5.817C215.569,215.691,214.687,215.04,213.6,215.04Z",
  transform: "translate(-211.627 -172.866)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_233",
  "data-name": "Trazado 233",
  d: "M213.6,324.266c-1.089,0-1.971.651-1.971,1.454v5.817c0,.8.882,1.454,1.971,1.454s1.971-.651,1.971-1.454V325.72C215.569,324.918,214.687,324.266,213.6,324.266Z",
  transform: "translate(-211.627 -258.823)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_234",
  "data-name": "Trazado 234",
  d: "M213.6,378.88c-1.089,0-1.971.651-1.971,1.454v5.817c0,.8.882,1.454,1.971,1.454s1.971-.651,1.971-1.454v-5.817C215.569,379.531,214.687,378.88,213.6,378.88Z",
  transform: "translate(-211.627 -301.803)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_235",
  "data-name": "Trazado 235",
  d: "M213.6,269.653c-1.089,0-1.971.651-1.971,1.454v5.817c0,.8.882,1.454,1.971,1.454s1.971-.651,1.971-1.454v-5.817C215.569,270.3,214.687,269.653,213.6,269.653Z",
  transform: "translate(-211.627 -215.845)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_236",
  "data-name": "Trazado 236",
  d: "M213.6,160.426c-1.089,0-1.971.651-1.971,1.454V167.7c0,.8.882,1.454,1.971,1.454s1.971-.651,1.971-1.454V161.88C215.569,161.078,214.687,160.426,213.6,160.426Z",
  transform: "translate(-211.627 -129.886)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_237",
  "data-name": "Trazado 237",
  d: "M213.6,51.2c-1.089,0-1.971.651-1.971,1.454v5.817c0,.8.882,1.454,1.971,1.454s1.971-.651,1.971-1.454V52.654C215.569,51.851,214.687,51.2,213.6,51.2Z",
  transform: "translate(-211.627 -43.928)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_238",
  "data-name": "Trazado 238",
  d: "M213.6,17.066c-1.089,0-1.971.651-1.971,1.454v1.454c0,.8.882,1.454,1.971,1.454s1.971-.651,1.971-1.454V18.52C215.569,17.718,214.687,17.066,213.6,17.066Z",
  transform: "translate(-211.627 -17.066)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_239",
  "data-name": "Trazado 239",
  d: "M213.6,105.813c-1.089,0-1.971.651-1.971,1.454v5.817c0,.8.882,1.454,1.971,1.454s1.971-.651,1.971-1.454v-5.817C215.569,106.464,214.687,105.813,213.6,105.813Z",
  transform: "translate(-211.627 -86.907)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_169",
  "data-name": "Grupo 169",
  transform: "translate(92.624 25.227)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_168",
  "data-name": "Grupo 168"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_240",
  "data-name": "Trazado 240",
  d: "M336.62,105.813c-9.625,0-15.766,14.427-15.766,24.359,0,11.923,8.426,13.452,15.766,13.452s15.766-1.529,15.766-13.452C352.385,120.24,346.245,105.813,336.62,105.813Zm0,34.9c-5.983,0-11.824-.814-11.824-10.543,0-10.224,6.189-21.451,11.824-21.451s11.824,11.226,11.824,21.451C348.444,139.9,342.6,140.716,336.62,140.716Z",
  transform: "translate(-320.854 -105.813)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_171",
  "data-name": "Grupo 171",
  transform: "translate(15.766 60.13)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_170",
  "data-name": "Grupo 170"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_33",
  "data-name": "Rect\\xE1ngulo 33",
  width: 3.941,
  height: 18.906
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_173",
  "data-name": "Grupo 173",
  transform: "translate(1.971 25.227)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_172",
  "data-name": "Grupo 172"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_241",
  "data-name": "Trazado 241",
  d: "M22.594,105.813c-9.625,0-15.766,14.427-15.766,24.359,0,11.923,8.426,13.452,15.766,13.452s15.766-1.529,15.766-13.452C38.359,120.24,32.218,105.813,22.594,105.813Zm0,34.9c-5.983,0-11.824-.814-11.824-10.543,0-10.224,6.189-21.451,11.824-21.451s11.824,11.226,11.824,21.451C34.418,139.9,28.577,140.716,22.594,140.716Z",
  transform: "translate(-6.828 -105.813)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_175",
  "data-name": "Grupo 175",
  transform: "translate(21.678 4.867)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_174",
  "data-name": "Grupo 174",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_242",
  "data-name": "Trazado 242",
  d: "M84.947,10.24c-6.015,0-9.853,7.419-9.853,11.3,0,4.195,4.42,7.607,9.853,7.607S94.8,25.733,94.8,21.538C94.8,17.659,90.963,10.24,84.947,10.24Zm0,16c-3.261,0-5.912-2.107-5.912-4.7,0-3.188,3.3-8.39,5.912-8.39s5.912,5.2,5.912,8.39C90.86,24.13,88.208,26.237,84.947,26.237Z",
  transform: "translate(-75.094 -10.24)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_177",
  "data-name": "Grupo 177",
  transform: "translate(84.741 4.867)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_176",
  "data-name": "Grupo 176",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_243",
  "data-name": "Trazado 243",
  d: "M303.4,10.24c-6.016,0-9.853,7.419-9.853,11.3,0,4.195,4.42,7.607,9.853,7.607s9.853-3.413,9.853-7.607C313.255,17.659,309.417,10.24,303.4,10.24Zm0,16c-3.261,0-5.912-2.108-5.912-4.7,0-3.188,3.3-8.39,5.912-8.39s5.912,5.2,5.912,8.39C309.313,24.13,306.662,26.237,303.4,26.237Z",
  transform: "translate(-293.548 -10.24)"
}))));

var SvgRoadScene = function SvgRoadScene(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126.126,
    height: 91.62,
    viewBox: "0 0 126.126 91.62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoadScene, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/road-scene.162a0bb8.svg";
export { ForwardRef as ReactComponent };